import type { ScheduleStore } from './interfaces'

export const createInitialState = (): ScheduleStore => ({
  loading: false,
  modalSchedule: false,
  modalScheduleSuccess: false,
  modalConfirmWeeklySchedule: false,
  availableSlots: [],
  selectedDate: null,
  selectedTime: null,
  timeMode: 'normal',
  availabilityById: {},
  weeklySchedule: [],
  selectedDays: [],
  showErrors: false,
})
